import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledPageContent = styled(Box)`
    height: 100%;
`;
